<script>
  import { Modal } from 'bootstrap';
  import { client } from 'root/api/index.js';
  import { onMount } from 'svelte';
  let addActivityDetailModal;
  let info = {
    title: '',
    notes: '',
    old: [],
    new: [],
  };

  onMount(() => {
    addActivityDetailModal = new Modal(document.getElementById('activityDetailModal'), {
      keyboard: false,
    });
  });

  export const showModal = (data) => {
    info = data;
    addActivityDetailModal.show();
  };
</script>

<!-- Modal -->
<div
  class="modal fade"
  id="activityDetailModal"
  tabindex="-1"
  aria-labelledby="activityDetailModal"
  aria-hidden="true"
>
  <div class="modal-dialog shadow">
    <div class="modal-content activity-content">
      <div class="modal-header">
        <h5
          class="modal-title font-size-14"
          id="exampleModalLabel"
        >
          {info.title}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="py-2 mb-2">
          <span class="font-size-14 font-weight-500 d-block">Note</span>
          <div class="d-flex flex-row flex-wrap">
            <span>{info.notes}</span>
          </div>
        </div>

        <div class="box-block rounded p-2 mb-3">
          <span class="title color-blue d-block mb-1">Old</span>
          {#each info.old as row, i}
            <div class="row">
              <div class="col-md-4">
                <span class="text-break">{row.label}</span>
              </div>
              <div class="col-md-8">
                <span class="text-break">{row.value}</span>
              </div>
            </div>
          {/each}
        </div>

        <div class="box-block rounded p-2">
          <span class="title color-blue d-block mb-1">New</span>
          {#each info.new as row, i}
            <div class="row">
              <div class="col-md-4">
                <span class="text-break">{row.label}</span>
              </div>
              <div class="col-md-8">
                <span class="text-break">{row.value}</span>
              </div>
            </div>
          {/each}
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="trans-btn my-0 px-4 font-size-12 outline-0 btn-cancel font-size-12"
          data-bs-dismiss="modal">Cancel</button
        >
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .shadow {
    box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.05);
  }
  .activity-content {
    .modal-body {
      max-height: 520px;
      overflow: auto;
    }
  }
</style>
